<template lang="html">
  <div class="duration">
    <h2 class="title is-5 has-text-centered">{{ title }}</h2>
    <ul class="steps is-narrow is-centered is-hollow has-gaps is-small">
      <li
        class="steps-segment"
        :class="{'is-active': index >= finishedStep, 'is-dashed': item.waiting}"
        :key="index"
        v-for="(item, index) in items"
        @click="finishedStep = index"
      >
        <span class="steps-marker"/>
        <div class="steps-content is-divider-content">
          <h6>{{ item.time }}</h6>
          <p class="heading">{{ item.name }}</p>
        </div>
      </li>
      <li class="steps-segment" @click="finishedStep = items.length">
        <span class="steps-marker"/>
      </li>
    </ul>
  </div>
</template>

<script>
import format from 'shared/lib/format'
const WAITING = {
  bake: true,
  cook: true,
  chill: true,
  cure: true,
  rest: true,
  rise: true
}
const DATA = window.__INIT_DATA.recipe || window.__INIT_DATA.wikiArticle || {}

export default {
  props: {
    times: {type: Array, default: () => DATA.times}
  },


  data(){
    return {
      finishedStep: 0
    }
  },

  computed: {
    title(){
      const total = this.times
      .filter(item => item.name !== 'total')
      .filter((item, index) => this.finishedStep - 1 < index)
      .map(item => item.minutes)
      .reduce((sum, min) => sum + min, 0)

      if(total === 0) return this.$t('enjoy you meal')
      if(this.finishedStep > 0) return this.$t('to go', [format.minutes(total)])

      return this.$t('preperation time', [format.minutes(total)])
    },

    items(){
      return this.times
      .filter(item => item.name !== 'total')
      .map(item => {
        return {
          name: this.$t(`times.${item.name}`),
          waiting: WAITING[item.name],
          time: format.minutes(item.minutes)
        }
      })
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "preperation time": "Zubereitungszeit: {0}",
    "enjoy you meal": "Mahlzeit",
    "to go": "Noch: {0}",
    "times": {
      "preparation": "Vorbereitung",
      "cooking": "Zubereitung",
      "bake": "Backen",
      "cook": "Garen",
      "boil": "Kochen",
      "roast": "Braten",
      "chill": "Kaltstellen",
      "cure": "Anziehen lassen",
      "rest": "Rasten lassen",
      "rise": "Aufgehen lassen"
    }
  },
  "en": {
    "preperation time": "preperation time: {0}",
    "enjoy you meal": "enjoy you meal",
    "to go": "to go: {0}",
    "times": {
      "preparation": "preparation",
      "cooking": "cooking",
      "bake": "bake",
      "cook": "cook",
      "boil": "boil",
      "roast": "roast",
      "chill": "chill",
      "cure": "cure",
      "rest": "rest",
      "rise": "rise"
    }
  },
  "cs": {
    "preperation time": "doba přípravy: {0}",
    "enjoy you meal": "jídlo",
    "to go": "ještě: {0}",
    "times": {
      "preparation": "příprava",
      "cooking": "vaření",
      "bake": "upéct",
      "cook": "kuchař",
      "boil": "vaříme",
      "roast": "pečeně",
      "chill": "chladný",
      "cure": "Povolit opotřebení",
      "rest": "Uvolněte západku",
      "rise": "Pojďme"
    }
  },
  "hu": {
    "preperation time": "felkészülési idő: {0}",
    "enjoy you meal": "élvezze az ételét",
    "to go": "{0} menni",
    "times": {
      "preparation": "készítmény",
      "cooking": "főzés",
      "bake": "süt",
      "cook": "szakács",
      "boil": "forral",
      "roast": "sült",
      "chill": "Hideg foltok",
      "cure": "Hagyjuk viselni",
      "rest": "Engedje el a reteszt",
      "rise": "Menjünk"
    }
  },
  "fr": {
    "preperation time": "temps de préparation: {0}",
    "enjoy you meal": "bon appétit",
    "to go": "{0} à parcourir",
    "times": {
      "preparation": "préparation",
      "cooking": "cuisine",
      "bake": "faire cuire au four",
      "cook": "cuisinier",
      "boil": "ébullition",
      "roast": "faire frire",
      "chill": "Points froids",
      "cure": "Laisser porter",
      "rest": "Relâchez le loquet",
      "rise": "Allons-y"
    }
  }
}
</i18n>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/TimesTimeline.vue